import { Link } from "react-router-dom";

export default function Impressum() {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Page Header */}
      <section className="pt-24 md:pt-32 pb-10 md:pb-14 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 mb-4 md:mb-6">
              <Link to="/" className="hover:text-primary-600 transition-colors">Startseite</Link>
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-s-line" /></span>
              <span className="text-foreground-700">Impressum</span>
            </nav>
            <h1 className="font-heading font-bold text-foreground-900 text-3xl md:text-4xl lg:text-5xl">
              Impressum
            </h1>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-10 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto space-y-8 md:space-y-10">
            <div>
              <h2 className="font-heading font-semibold text-foreground-900 text-lg md:text-xl mb-3 md:mb-4">
                Angaben gemäß § 5 TMG
              </h2>
              <address className="not-italic text-sm md:text-base text-foreground-600 leading-relaxed">
                <p className="font-medium text-foreground-800">
                  Draude & Wagner Galvanik GmbH & Co. KG
                </p>
                <p>Im Grund 11</p>
                <p>58513 Lüdenscheid</p>
                <p className="mt-3">Deutschland</p>
              </address>
            </div>

            <div>
              <h2 className="font-heading font-semibold text-foreground-900 text-lg md:text-xl mb-3 md:mb-4">
                Vertreten durch
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                Geschäftsführer: Olaf Nölle
              </p>
            </div>

            <div>
              <h2 className="font-heading font-semibold text-foreground-900 text-lg md:text-xl mb-3 md:mb-4">
                Kontakt
              </h2>
              <ul className="space-y-1.5 text-sm md:text-base text-foreground-600">
                <li>Telefon: +49 2351 123456</li>
                <li>E-Mail: info@dw-galvanik.de</li>
                <li>Website: www.dw-galvanik.de</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading font-semibold text-foreground-900 text-lg md:text-xl mb-3 md:mb-4">
                Registereintrag
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                Eintragung im Handelsregister.<br />
                Registergericht: Amtsgericht Iserlohn<br />
                Registernummer: HRA 3111
              </p>
            </div>

            <div>
              <h2 className="font-heading font-semibold text-foreground-900 text-lg md:text-xl mb-3 md:mb-4">
                Umsatzsteuer-ID
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
                DE 125796179
              </p>
            </div>

            <div>
              <h2 className="font-heading font-semibold text-foreground-900 text-lg md:text-xl mb-3 md:mb-4">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <address className="not-italic text-sm md:text-base text-foreground-600 leading-relaxed">
                <p></p>
                <p>Draude & Wagner Galvanik GmbH & Co. KG</p>
                <p>Im Grund 11</p>
                <p>58513 Lüdenscheid</p>
              </address>
            </div>

            <div>
              <h2 className="font-heading font-semibold text-foreground-900 text-lg md:text-xl mb-3 md:mb-4">
                Streitschlichtung
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer nofollow" className="text-primary-600 hover:text-primary-700 underline">
                  https://ec.europa.eu/consumers/odr/
                </a>
                <br /><br />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.<br /><br />
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>

            <div>
              <h2 className="font-heading font-semibold text-foreground-900 text-lg md:text-xl mb-3 md:mb-4">
                Haftung für Inhalte
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>
            </div>

            <div>
              <h2 className="font-heading font-semibold text-foreground-900 text-lg md:text-xl mb-3 md:mb-4">
                Haftung für Links
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>
            </div>

            <div>
              <h2 className="font-heading font-semibold text-foreground-900 text-lg md:text-xl mb-3 md:mb-4">
                Urheberrecht
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}